@let texts = textStore.texts();

<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [footer]="footer"
  [width]="width"
  [data]="data"
  [title]="
    texts
      | filterTexts: ERelationType.headline : EEntityType.removePaymentMethod
      | language
  ">
  <ng-template #content>
    <div>
      {{
        texts
          | filterTexts
            : ERelationType.description
            : EEntityType.removePaymentMethod
          | language
      }}
    </div>
  </ng-template>
  <ng-template #footer>
    <aw-button
      [id]="'confirm'"
      [type]="'button'"
      (click)="dialogRef.close({ submit: true, data, acceptChanges: false })"
      [text]="
        texts
          | filterTexts: ERelationType.remove : EEntityType.removePaymentMethod
          | language
      "
      class="mr-3 w-full" />
    <aw-button
      class="w-full"
      [id]="'cancel'"
      [type]="'button'"
      (click)="dialogRef.close()"
      [style]="'primary-alt'"
      [text]="
        texts
          | filterTexts: ERelationType.cancel : EEntityType.generic
          | language
      " />
  </ng-template>
</aw-dialog>
